// Short optional text input with character counter

export interface NoteInput {
  root: HTMLElement;
  textarea: HTMLTextAreaElement;
  getValue: () => string;
}

export function createNoteInput(id: string, placeholder = 'Optional note (max 100 chars)'): NoteInput {
  const wrapper = document.createElement('div');
  wrapper.className = 'space-y-2';

  const label = document.createElement('label');
  label.setAttribute('for', id);
  label.className = 'text-sm font-medium text-gray-800';
  label.textContent = 'Note (optional)';

  const textarea = document.createElement('textarea');
  textarea.id = id;
  textarea.maxLength = 100;
  textarea.rows = 3;
  textarea.className = 'w-full rounded-lg border px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500';
  textarea.placeholder = placeholder;

  const counter = document.createElement('div');
  counter.className = 'text-xs text-gray-500 text-right';
  counter.textContent = '0 / 100';

  textarea.addEventListener('input', () => {
    counter.textContent = `${textarea.value.length} / 100`;
  });

  wrapper.appendChild(label);
  wrapper.appendChild(textarea);
  wrapper.appendChild(counter);

  return {
    root: wrapper,
    textarea,
    getValue: () => textarea.value.trim(),
  };
}
